// Packages
import { Component } from "react";
import "bootstrap/dist/css/bootstrap.css";
import rightangle from "../../assets/images/rightangle.svg";
import { Form } from "react-bootstrap";
import { Button, Modal } from "react-bootstrap";
import { Link, Redirect } from "react-router-dom";
// Views
import SuperAdminDashboard from "../superAdmin/superAdminDashboard";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import leftarrow from "../../assets/images/leftarrow.svg";
// Styles
import "./superAdmin.css";
import userService from "../../services/user.service";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import successimg from "../../assets/images/successimg.png";
import close from "../../assets/images/crosstick.png";
import AddIcon from "@material-ui/icons/Add";
import capton from "../../assets/images/capton.png";
import { BsXLg } from "react-icons/bs";
import Testimonials from "./Testimonials/Testimonials";
import { getFromLocalStorage } from "../../utils/webStorage";
import SoftwareStrengths from "./Modals/SoftwareStrength";
import CompanyTagline from "./LandingPageTabPanel/CompanyTagline";
import Features from "./LandingPageTabPanel/Features";
import CompletelyIntegrated from "./LandingPageTabPanel/CompletelyIntegrated";
import SportsAnalysis from "./LandingPageTabPanel/SportsAnalysis";
import GetPremium from "./LandingPageTabPanel/GetPremium";
import { tablist } from "./LandingPageTabList";
import { map, get } from "lodash";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Paper } from "@material-ui/core";
import PageNotFoundPage from "../../Common/PageNotFoundPage";

// Material Ui

class WebsiteDetails extends Component {
  constructor() {
    super();
    this.state = {
      showfive: false,
      showSix: false,
      showEdit: false,
      showSuccess: false,
      showEditFirst: false,
      showEditSecond: false,
      companyTagline: "",
      subTagline: "",
      details: "",
      logoId: null,
      title: "",
      fileAddress: "",
      imagePreviewUrl: "",
      file: "",
      showMessage: "",
      openSuccess: false,
      titleSport: "",
      detailsSport: "",
      titleWeek: "",
      detailsWeek: "",
      detailSoft: "",
      titleSoft: "",
      testimonialsHeading: "",
      testimonialsdetails: "",
      name: "",
      captian: "",
      content: "",
      taglineDetailsResponses: [],
      softwareStrengthsDetails: [],
      tagId: null,
      capture: "",
      featureId: null,
      weekId: null,
      titleIntegration: "",
      detailsIntegration: "",
      imageIntegrationUrl: "",
      titleIntegration: "",
      detailsIntegration: "",
      logoIDIntegration: "",
      integrationID: "",
      detailsSports: "",
      logoIDSports: "",
      titleSports: "",
      sportsID: "",
      imageSportAnalysisUrl: "",
      detailsSoftwareStrengths: "",
      logoIDSoftwareStrengths: "",
      titleSoftwareStrengths: "",
      softwareStrengthsID: "",
      imageNameIDSports: "",
      imageNameIntegration: "",
      testimonialsHeadingWeb: "",
      testimonialsdetailsWeb: "",
      testimonialsNameWeb: "",
      testimonialsCaptionWeb: "",
      testimonialsContentWeb: "",
      testimonialsIdWeb: "",
      testimonialsLogoId: "",
      testimonialsImagefileName: "",
      testimonialsImagefilePath: "",
      testimonialsNameWeb1: "",
      testimonialsCaptionWeb1: "",
      testimonialsContentWeb1: "",
      testimonialsIdWeb1: "",
      testimonialsLogoId1: "",
      testimonialsImagefileName1: "",
      testimonialsImagefilePath1: "",
      SoftStreIdToSend: "",
      SoftStreDetails: "",
      SoftStreTitle: "",
      SoftStrefileName: "",
      SoftStrefilePath: "",
      SoftStreImagID: "",
      disabled: false,
      openModal: false,
      iconId: null,
      iconFilename: "",
      setTabList: "",
      redirect: false,
      loginRole: getFromLocalStorage("loginRole"),
    };

    this.changeHandlerIntegrated = this.changeHandlerIntegrated.bind(this);
    this.changeHandlerSportz = this.changeHandlerSportz.bind(this);
    this.changeHandlerSoftwareStrength =
      this.changeHandlerSoftwareStrength.bind(this);
    this.changeHandlertestimonials = this.changeHandlertestimonials.bind(this);
    this.changeHandlerteSoftStre = this.changeHandlerteSoftStre.bind(this);
    this.changeHandlertestimonials1 =
      this.changeHandlertestimonials1.bind(this);
  }
  handleModelfive() {
    this.setState({ showfive: !this.state.showfive });
  }
  handleModelSix() {
    this.setState({ showSix: !this.state.showSix });
  }
  handleModelEdit(id) {
    this.setState({ showEdit: !this.state.showEdit });
    this.getSoftwareStreById(id);
  }
  handleModelEditFirst() {
    this.setState({ showEditFirst: !this.state.showEditFirst });
  }
  handleModelEditSecond() {
    this.setState({ showEditSecond: !this.state.showEditSecond });
  }

  handleModelSuccess() {
    this.setState({ showSuccess: !this.state.showSuccess });
    this.setState({ showEditFirst: !this.state.showEditFirst });
    this.setState({ showEditSecond: !this.state.showEditSecond });
  }

  componentDidMount() {
    // this.handleModelEdit();
    const acticve = document.getElementById("Website");
    if (acticve) {
      acticve.classList.add("active");
    }
    this.getAllTagline();
    this.getfeatureDetails();
    this.getPremiumWeek();
    this.getAllIntegration();
    this.getAllSportsAnalysis();
    this.getAllSoftwareStrengths();
  }

  getSoftwareStreById(id) {
    userService.getSoftwareStrengthsById(id).then((res) => {
      const SoftStreIdToSend = id;
      const SoftStreDetails = res.data.data.details;
      const SoftStreTitle = res.data.data.title;
      const SoftStrefileName = res.data.data.uploadedLogo.fileName;
      const SoftStreImagID = res.data.data.uploadedLogo.id;
      const SoftStrefilePath = res.data.data.uploadedLogo.filePath;
      this.setState({
        SoftStreIdToSend,
        SoftStreDetails,
        SoftStreTitle,
        SoftStrefileName,
        SoftStreImagID,
        SoftStrefilePath,
      });
    });
  }

  updateSoftStrePost() {
    const { SoftStreDetails, SoftStreIdToSend, SoftStreImagID, SoftStreTitle } =
      this.state;
    userService
      .updateSoftwareStrengthsWeb(
        SoftStreDetails,
        SoftStreIdToSend,
        SoftStreImagID,
        SoftStreTitle
      )
      .then((res) => {
        const showMessage = res.data.data;
        this.setState({ showMessage });
        this.openDialogSuccess();
      });
  }

  getAllIntegration = () => {
    userService.getAllIntegration().then((res) => {
      const titleIntegration =
        res.data.data.integratedDetailsResponses[0].title;
      const detailsIntegration =
        res.data.data.integratedDetailsResponses[0].details;
      const imageIntegrationUrl =
        res.data.data.integratedDetailsResponses[0].uploadedLogo.filePath;
      const integrationID = res.data.data.integratedDetailsResponses[0].id;
      const logoIDIntegration =
        res.data.data.integratedDetailsResponses[0].uploadedLogo.id;
      const imageNameIntegration =
        res.data.data.integratedDetailsResponses[0].uploadedLogo.fileName;
      this.setState({
        titleIntegration,
        detailsIntegration,
        imageIntegrationUrl,
        integrationID,
        logoIDIntegration,
        imageNameIntegration,
      });
    });
  };

  completelyPostCall() {
    const { details, logoId, title } = this.state;
    userService.addCompletelyPost(details, logoId, title).then((res) => {
      const showMessage = res.data.data;
      this.setState({ showMessage });
      this.openDialogSuccess();
    });
  }

  updateAllIntegrated = ({ title, details }) => {
    this.setState({ disabled: true });
    const {
      detailsIntegration,
      logoIDIntegration,
      titleIntegration,
      integrationID,
    } = this.state;
    userService
      .updateIntegrated(details, logoIDIntegration, title, integrationID)
      .then((res) => {
        let showMessage = res.data.data;
        this.setState({ showMessage, disabled: false });
        this.openDialogSuccess();
      });
  };

  getAllSportsAnalysis = () => {
    userService.getSportsAnalysis().then((res) => {
      const titleSports = res.data.data.sportsAnalysisDetailsResponses[0].title;
      const detailsSports =
        res.data.data.sportsAnalysisDetailsResponses[0].details;
      const imageSportAnalysisUrl =
        res.data.data.sportsAnalysisDetailsResponses[0].uploadedLogo.filePath;
      const sportsID = res.data.data.sportsAnalysisDetailsResponses[0].id;
      const logoIDSports =
        res.data.data.sportsAnalysisDetailsResponses[0].uploadedLogo.id;
      const imageNameIDSports =
        res.data.data.sportsAnalysisDetailsResponses[0].uploadedLogo.fileName;
      this.setState({
        titleSports,
        detailsSports,
        imageSportAnalysisUrl,
        sportsID,
        logoIDSports,
        imageNameIDSports,
      });
    });
  };

  updateAllSportsAnalysisWeb = ({ title, details }) => {
    this.setState({ disabled: true });
    const { logoIDSports, sportsID } = this.state;
    userService
      .updateSportsAnalysisWeb(details, logoIDSports, title, sportsID)
      .then((res) => {
        let showMessage = res.data.data;
        this.setState({ showMessage, disabled: false });
        this.openDialogSuccess();
      });
  };

  updateAllSoftwareStrengthsWeb() {
    const {
      detailsSoftwareStrengths,
      logoIDSoftwareStrengths,
      titleSoftwareStrengths,
      softwareStrengthsID,
    } = this.state;
    userService
      .updateSoftwareStrengthsWeb(
        detailsSoftwareStrengths,
        logoIDSoftwareStrengths,
        titleSoftwareStrengths,
        softwareStrengthsID
      )
      .then((res) => {
        const showMessage = res.data.data;
        this.setState({ showMessage });
        this.openDialogSuccess();
      });
  }

  getAllSoftwareStrengths() {
    userService.getSoftwareStrengths().then((res) => {
      const softwareStrengthsDetails =
        res.data.data.softwareStrengthsDetailsResponses;
      this.setState({ softwareStrengthsDetails });
    });
  }

  changeHandlertestimonials = (event) => {
    this.selectedFile = event.target.files[0];
    let reader = new FileReader();
    let file = event.target.files[0];

    reader.onloadend = () => {
      this.setState({
        file: file,
        testimonialsImagefilePath: reader.result,
      });
    };
    reader.readAsDataURL(file);
    this.handleSubmissionForLogo();
  };

  changeHandlerteSoftStre = (event) => {
    this.selectedFile = event.target.files[0];
    let reader = new FileReader();
    let file = event.target.files[0];

    reader.onloadend = () => {
      this.setState({
        file: file,
        testimonialsImagefilePath: reader.result,
      });
    };
    reader.readAsDataURL(file);
    this.handleSubmissionForLogo();
  };

  changeHandlertestimonials1 = (event) => {
    this.selectedFile = event.target.files[0];
    let reader = new FileReader();
    let file = event.target.files[0];

    reader.onloadend = () => {
      this.setState({
        file: file,
        testimonialsImagefilePath1: reader.result,
      });
    };
    reader.readAsDataURL(file);
    this.handleSubmissionForLogosecond();
  };

  changeHandlerSoftwareStrength = (event, formRef) => {
    this.selectedFile = event.target.files[0];
    let reader = new FileReader();
    let file = event.target.files[0];

    reader.onloadend = () => {
      this.setState({
        file: file,
        SoftStrefilePath: reader.result,
      });
    };
    reader.readAsDataURL(file);
    this.handleSubmissionForLogo(formRef);
  };

  changeHandlerSportz = (event) => {
    this.selectedFile = event.target.files[0];
    let reader = new FileReader();
    let file = event.target.files[0];

    reader.onloadend = () => {
      this.setState({
        file: file,
        imageSportAnalysisUrl: reader.result,
      });
    };
    reader.readAsDataURL(file);
    this.handleSubmissionForLogo();
  };

  changeHandlerIntegrated = (event) => {
    this.selectedFile = event.target.files[0];
    let reader = new FileReader();
    let file = event.target.files[0];

    reader.onloadend = () => {
      this.setState({
        file: file,
        imageIntegrationUrl: reader.result,
      });
    };
    reader.readAsDataURL(file);
    this.handleSubmissionForLogo();
  };

  handleSubmissionForLogo = (formRef) => {
    const currentUserId = getFromLocalStorage("currentUserId");
    const data = new FormData();
    data.append("file", this.selectedFile);
    data.append("userId", currentUserId);
    userService.postLogoForSuperAdmin(data).then((res) => {
      formRef.current.setFieldValue("selectedFileName", res.data.data.filePath);
      const logoId = res.data.data.id;
      const fileAddress = res.data.data.filePath;
      const logoIDSports = res.data.data.id;
      const logoIDIntegration = res.data.data.id;
      const testimonialsLogoId = res.data.data.id;
      const SoftStreImagID = res.data.data.id;
      const iconFilename = res.data.data.fileName;
      this.setState({
        logoId,
        fileAddress,
        logoIDSports,
        logoIDIntegration,
        testimonialsLogoId,
        SoftStreImagID,
        iconFilename,
      });
    });
  };

  handleSubmissionForLogosecond = () => {
    const currentUserId = getFromLocalStorage("currentUserId");
    const data = new FormData();
    data.append("file", this.selectedFile);
    data.append("userId", currentUserId);
    userService.postLogoForSuperAdmin(data).then((res) => {
      const testimonialsLogoId1 = res.data.data.id;
      this.setState({ testimonialsLogoId1 });
    });
  };

  getAllTagline = () => {
    const { companyTagline, subTagline } = this.state;
    userService.getAllTagline().then((res) => {
      const taglineDetailsResponses = res.data.data.taglineDetailsResponses;
      const companyTagline =
        res.data.data.taglineDetailsResponses[0].companyTagline;
      const subTagline = res.data.data.taglineDetailsResponses[0].subTagline;
      const tagId = res.data.data.taglineDetailsResponses[0].id;
      this.setState({
        taglineDetailsResponses,
        companyTagline,
        subTagline,
        tagId,
      });
    });
  };

  taglinePostCall() {
    const { companyTagline, subTagline } = this.state;
    userService.addTaglinePost(companyTagline, subTagline).then((res) => {
      const showMessage = res.data.data;
      this.setState({ showMessage });
      this.openDialogSuccess();
    });
  }

  taglinePostUpdatedCall = ({ companyTagline, companySubTagline }) => {
    this.setState({ disabled: true });
    const { tagId } = this.state;
    userService
      .updateTaglinePost(companyTagline, companySubTagline, tagId)
      .then((res) => {
        const showMessage = res.data.data;
        this.setState({ showMessage, disabled: false });
        this.openDialogSuccess();
      });
  };

  sportPostCall() {
    const { detailsSport, logoId, titleSport } = this.state;
    userService.addSportPost(detailsSport, logoId, titleSport).then((res) => {
      const showMessage = res.data.data;
      this.setState({ showMessage });
      this.openDialogSuccess();
    });
  }

  featurePostCall() {
    const {
      analysis,
      dataImports,
      kpi,
      presentations,
      review,
      teams,
      capture,
    } = this.state;
    userService
      .addFeaturePost(
        analysis,
        dataImports,
        kpi,
        presentations,
        review,
        teams,
        capture
      )
      .then((res) => {
        const showMessage = res.data.data;
        this.setState({ showMessage });
        this.openDialogSuccess();
      });
  }

  getfeatureDetails() {
    const {
      analysis,
      dataImports,
      kpi,
      presentations,
      review,
      teams,
      capture,
    } = this.state;
    userService.getAllFeatures().then((res) => {
      const analysis = res.data.data.featuresDetailsResponses[0].analysis;
      const dataImports = res.data.data.featuresDetailsResponses[0].dataImports;
      const kpi = res.data.data.featuresDetailsResponses[0].kpi;
      const presentations =
        res.data.data.featuresDetailsResponses[0].presentations;
      const review = res.data.data.featuresDetailsResponses[0].review;
      const teams = res.data.data.featuresDetailsResponses[0].teams;
      const capture = res.data.data.featuresDetailsResponses[0].capture;
      const featureId = res.data.data.featuresDetailsResponses[0].id;
      this.setState({
        analysis,
        dataImports,
        kpi,
        presentations,
        review,
        teams,
        capture,
        featureId,
      });
    });
  }

  featurePostUpdateCall = ({
    feature1,
    feature2,
    feature3,
    feature4,
    feature5,
    feature6,
    feature7,
  }) => {
    this.setState({ disabled: true });
    const { featureId } = this.state;
    userService
      .updateFeaturePost(
        feature3,
        feature6,
        feature4,
        feature2,
        feature5,
        feature1,
        feature7,
        featureId
      )
      .then((res) => {
        const showMessage = res.data.data;
        this.setState({ showMessage, disabled: false });
        this.openDialogSuccess();
      });
  };

  weekPostCall() {
    const { titleWeek, detailsWeek } = this.state;
    userService.addWeekPost(titleWeek, detailsWeek).then((res) => {
      const showMessage = res.data.data;
      this.setState({ showMessage });
      this.openDialogSuccess();
    });
  }

  getPremiumWeek = () => {
    userService.getAllPremiumWeeks().then((res) => {
      const detailsWeek = res.data.data.weeksDetailsResponses[0].details;
      const titleWeek = res.data.data.weeksDetailsResponses[0].title;
      const weekId = res.data.data.weeksDetailsResponses[0].id;
      this.setState({ detailsWeek, titleWeek, weekId });
    });
  };

  weekPostUpdateCall = ({ title, details }) => {
    this.setState({ disabled: true });
    const { weekId } = this.state;
    userService.updateWeekPost(title, details, weekId).then((res) => {
      let showMessage = res.data.data;
      this.setState({ showMessage, disabled: false });
      this.openDialogSuccess();
    });
  };

  softwarePostCall = ({ title, details }) => {
    const { logoId } = this.state;
    userService.addSoftPost(title, details, logoId).then((res) => {
      const showMessage = res.data.data;
      this.setState({ showMessage });
      this.openDialogSuccess();
    });
  };

  handleSoftwareStrengthtitle = (e) => {
    this.setState({ titleSoft: e.target.value });
  };

  handleSoftwareStrengthdetails = (e) => {
    this.setState({ detailSoft: e.target.value });
  };

  testimonialsPostCall() {
    const {
      testimonialsHeading,
      testimonialsdetails,
      name,
      captian,
      content,
      logoId,
    } = this.state;
    userService
      .addTestimonialPost(
        testimonialsHeading,
        testimonialsdetails,
        name,
        captian,
        content,
        logoId
      )
      .then((res) => {
        const showMessage = res.data.data;
        this.setState({ showMessage });
        this.openDialogSuccess();
      });
  }

  openDialogSuccess() {
    this.setState({ openSuccess: !this.state.openSuccess });
  }
  closeDialogSuccess() {
    this.setState({ openSuccess: !this.state.openSuccess });
  }

  openStrengthModal() {
    this.setState({ openModal: true });
  }

  closeModal = () => {
    this.setState({ openModal: false });
  };
  // field change
  onFieldChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  render() {
    const {
      fileAddress,
      showMessage,
      titleIntegration,
      detailsIntegration,
      imageIntegrationUrl,
      titleSports,
      detailsSports,
      imageSportAnalysisUrl,
      imageNameIDSports,
      imageNameIntegration,
      softwareStrengthsDetails,
      SoftStreIdToSend,
      SoftStreDetails,
      SoftStreTitle,
      SoftStrefileName,
      SoftStrefilePath,
      disabled,
      setTabList,
      companyTagline,
      subTagline,
      taglineDetailsResponses,
      teams,
      presentations,
      analysis,
      kpi,
      review,
      dataImports,
      capture,
      titleWeek,
      detailsWeek,
      openModal,
      iconFilename,
      detailSoft,
      titleSoft,
      openSuccess,
      showfive,
      showSix,
      showEditFirst,
      showEditSecond,
      showEdit,
      showSuccess,
      redirect,
      loginRole,
    } = this.state;

    if (redirect) {
      return <Redirect to="/website" />;
    }

    return (
      <>
        {loginRole === "SUPER ADMIN" ? (
          <div className="">
            <SuperAdminDashboard />
            <div className="content-layout">
              <Tabs>
                <div className="row w-100 ">
                  <div className="col-12 col-md-4 col-lg-3 w-100 fixed-left-container">
                    <TabList className="w-100">
                      <div className="pd-5">
                        <button
                          className="custom-back-button mg-bottom-10 mg-top-10"
                          onClick={() => this.setState({ redirect: true })}
                        >
                          <span className="custom-back-button-icon">
                            <ArrowBackIcon className="backarrow-icon" />
                          </span>
                          <div className="custom-back-button-text d-flex-center w-100">
                            <span className="bold fs-18">Manage Main Page</span>
                          </div>
                        </button>
                      </div>
                      {map(tablist, (item, index) => {
                        return (
                          <Tab>
                            <div className="landing-dtls">
                              <p>{item.text}</p>
                              <span className="parz">
                                <img src={rightangle} alt=""></img>
                              </span>
                            </div>
                          </Tab>
                        );
                      })}
                    </TabList>
                  </div>
                  {/* PErsonal info */}
                  <div className="col-12 col-md-8 col-lg-9 w-100">
                    <TabPanel>
                      <div className="height-90-vh">
                        <Paper className="mg-10 pd-10">
                          <CompanyTagline
                            companyTagline={companyTagline}
                            subTagline={subTagline}
                            getAllTagline={this.getAllTagline}
                            taglinePostUpdatedCall={
                              taglineDetailsResponses
                                ? this.taglinePostUpdatedCall
                                : this.taglinePostCall
                            }
                            onFieldChange={this.onFieldChange}
                            disabled={disabled}
                          />
                        </Paper>
                      </div>
                    </TabPanel>
                    {/* Header Menu */}
                    <TabPanel>
                      <div className="height-90-vh">
                        <Paper className="mg-10 pd-10">
                          <Features
                            teams={teams}
                            presentations={presentations}
                            analysis={analysis}
                            kpi={kpi}
                            review={review}
                            dataImports={dataImports}
                            capture={capture}
                            getAllTagline={this.getAllTagline}
                            featurePostUpdateCall={this.featurePostUpdateCall}
                            onFieldChange={this.onFieldChange}
                            disabled={disabled}
                          />
                        </Paper>
                      </div>
                    </TabPanel>
                    {/* Footer section */}
                    <TabPanel>
                      <div className="height-90-vh">
                        <Paper className="mg-10 pd-10">
                          <CompletelyIntegrated
                            titleIntegration={titleIntegration}
                            detailsIntegration={detailsIntegration}
                            changeHandlerIntegrated={
                              this.changeHandlerIntegrated
                            }
                            imageNameIntegration={imageNameIntegration}
                            imageIntegrationUrl={imageIntegrationUrl}
                            getAllIntegration={this.getAllIntegration}
                            disabled={disabled}
                            updateAllIntegrated={this.updateAllIntegrated}
                            onFieldChange={this.onFieldChange}
                          />
                        </Paper>
                      </div>
                    </TabPanel>

                    <TabPanel>
                      <div className="height-90-vh">
                        <Paper className="mg-10 pd-10">
                          <SportsAnalysis
                            titleSports={titleSports}
                            detailsSports={detailsSports}
                            changeHandlerSportz={this.changeHandlerSportz}
                            imageNameIDSports={imageNameIDSports}
                            imageSportAnalysisUrl={imageSportAnalysisUrl}
                            getAllSportsAnalysis={this.getAllSportsAnalysis}
                            disabled={disabled}
                            updateAllSportsAnalysisWeb={
                              this.updateAllSportsAnalysisWeb
                            }
                            onFieldChange={this.onFieldChange}
                          />
                        </Paper>
                      </div>
                    </TabPanel>

                    <TabPanel>
                      <div className="height-90-vh">
                        <Paper className="mg-10 pd-10">
                          <GetPremium
                            titleWeek={titleWeek}
                            detailsWeek={detailsWeek}
                            getPremiumWeek={this.getPremiumWeek}
                            weekPostUpdateCall={this.weekPostUpdateCall}
                            onFieldChange={this.onFieldChange}
                            disabled={disabled}
                          />
                        </Paper>
                      </div>
                    </TabPanel>

                    <TabPanel>
                      <div className="panel-content conclass-website">
                        <div className="row">
                          <div className="col-12">
                            <div className="d-flex justify-content-center align-items-center testiBOX-new bg-light border">
                              <button
                                onClick={() => this.openStrengthModal()}
                                type="button"
                                class="testimonial-btn"
                                data-toggle="modal"
                                data-target="#exampleModal"
                                data-whatever="@mdo"
                              >
                                + ADD
                              </button>
                            </div>
                          </div>
                          <SoftwareStrengths
                            openModal={openModal}
                            closeModal={this.closeModal}
                            changeHandlerSoftwareStrength={
                              this.changeHandlerSoftwareStrength
                            }
                            fileName={iconFilename}
                            handleSoftwareStrengthtitle={
                              this.handleSoftwareStrengthtitle
                            }
                            handleSoftwareStrengthdetails={
                              this.handleSoftwareStrengthdetails
                            }
                            name={titleSoft}
                            content={detailSoft}
                            softwarePostCall={this.softwarePostCall}
                          />
                        </div>
                        <div className="row">
                          {softwareStrengthsDetails &&
                            softwareStrengthsDetails.map((item, index) => (
                              <div className="col-12 col-lg-4 col-md-4 col-xl-4">
                                <div
                                  className="testiBOX"
                                  style={{ position: "relative" }}
                                >
                                  <p className="fs-16 semi-bold black">
                                    {item.title}
                                  </p>
                                  <div className="clear10"></div>
                                  <p className="fs-16  regular greyTEXT">
                                    {item.details}
                                  </p>
                                  <div className="clear10"></div>
                                  <h1
                                    className="fs-16 semi-bold txtblue cp"
                                    onClick={() => {
                                      this.handleModelEdit(item.id);
                                    }}
                                    style={{
                                      position: "absolute",
                                      bottom: "10px",
                                      right: "10px",
                                    }}
                                  >
                                    <u>EDIT</u>
                                  </h1>
                                </div>
                                <hr></hr>
                              </div>
                            ))}
                        </div>
                        <hr></hr>
                      </div>
                    </TabPanel>

                    <TabPanel>
                      <Testimonials />
                    </TabPanel>
                  </div>
                </div>
              </Tabs>
            </div>

            {/* suceess dialog */}

            <Dialog
              id="dialogBoxCancel"
              className="dialog-style updateschool"
              open={openSuccess}
              onClose={this.closeDialogSuccess.bind(this)}
            >
              <DialogTitle>
                <div className="row">
                  <div className="col-1 text-right ml-auto">
                    <BsXLg
                      onClick={this.closeDialogSuccess.bind(this)}
                      className="crossview cp"
                    ></BsXLg>
                  </div>
                </div>
              </DialogTitle>
              <DialogContent>
                <div className="clear10"></div>
                <div className="row">
                  <div className="col-12 text-center">
                    <img
                      src={successimg}
                      alt="success"
                      className="successimg-new"
                    ></img>
                    <div className="clear20"></div>
                    <p className="fs-20 semi-bold text-center">{showMessage}</p>
                    <div className="clear30"></div>
                  </div>
                  <div className="col-12 col-md-12 col-lg-12 ml-auto text-center">
                    <button
                      type="button"
                      class="donebtn"
                      onClick={this.closeDialogSuccess.bind(this)}
                    >
                      Ok
                    </button>
                  </div>
                </div>

                <div className="clear10"></div>

                <div className="clear10"></div>
              </DialogContent>
            </Dialog>
            {/* end */}

            <Modal
              id="mwidth"
              show={showfive}
              onHide={() => {
                this.handleModelfive();
              }}
            >
              <Modal.Header>
                <div className="d-flex justify-content-between w-100">
                  <h6 className="fs-20 semi-bold"></h6>
                  <BsXLg
                    onClick={() => this.handleModelfive()}
                    className="crossview cp"
                  ></BsXLg>
                </div>
              </Modal.Header>
              <Modal.Body>
                <div className="row">
                  <div className="col-md-6 col-lg-6 text-center mx-auto">
                    <h6 className="fs-20 semi-bold black text-center">
                      Are You Sure?
                    </h6>
                    <p className="fs-16 semi-bold black">
                      Clicking on “Yes, Hide” will Hide the selected Header Menu
                      from the system!
                    </p>
                    <div className="clear10"></div>
                    {/* <input type="text" className="olnone form-control regular" placeholder="Enter"></input> */}
                  </div>
                  <div className="col-12 col-lg-12">
                    <button type="button" className="cancelbtn mr-2">
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="canredbtn"
                      onClick={() => {
                        this.handleModelfive();
                      }}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                {/* <Button className="fs-16 regular" onClick={() => { this.handleModelfive() }}>
              Post
              </Button> */}
              </Modal.Footer>
            </Modal>

            {/* EDIT MODAL */}
            <Modal
              id="mwidth"
              show={showEdit}
              onHide={() => {
                this.handleModelEdit();
              }}
            >
              <Modal.Header>
                <div className="d-flex justify-content-between w-100">
                  <h1 className="fs-20 semi-bold">EDIT</h1>
                  <BsXLg
                    onClick={() => this.handleModelEdit()}
                    className="crossview cp"
                  ></BsXLg>
                </div>
              </Modal.Header>
              <Modal.Body>
                <label className="fs-18 semi-bold">ICON IMAGE</label>
                <div>
                  <label
                    htmlFor="filePicker"
                    className="browseBTN"
                    style={{ padding: "12px 10px" }}
                  >
                    <u>Browse</u>
                  </label>
                  <span className="pl-3 fs-18 medium txtblue">
                    {SoftStrefileName}
                  </span>

                  <input
                    id="filePicker"
                    style={{ visibility: "hidden" }}
                    type={"file"}
                    onChange={this.changeHandlerteSoftStre}
                  ></input>
                  <p className="newgreyTXT imgsizeTXT">
                    Image Size : 80 px * 80 px
                  </p>
                </div>
                <p className="fs-18 semi-bold black">
                  TITLE{" "}
                  <span className="fs-16 regular newgreyTXT">
                    (Character Limit 20)
                  </span>
                </p>
                <div className="clear10"></div>
                <input
                  type="text"
                  className="titleTXT black"
                  placeholder="Import/Upload Footage"
                  onChange={(event) => {
                    this.setState({ SoftStreTitle: event.target.value });
                  }}
                  value={SoftStreTitle}
                />
                <div className="clear10"></div>
                <p className="fs-18 semi-bold black">
                  DECRIPTION{" "}
                  <span className="fs-16 regular newgreyTXT">
                    (Character Limit 140)
                  </span>
                </p>
                <div className="clear10"></div>
                <textarea
                  className="descTXT"
                  placeholder="Use video and data analysis to detect vulnerabilities. Decide what to focus on and develop technical and tactical strategies to improve performance and reduce injuries."
                  onChange={(event) => {
                    this.setState({ SoftStreDetails: event.target.value });
                  }}
                  value={SoftStreDetails}
                />
              </Modal.Body>
              <Modal.Footer>
                <button
                  className="btn btn-cancel fs-16"
                  // onClick={this.handleModelEdit}
                  onClick={() => {
                    this.handleModelEdit();
                  }}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-save fs-16"
                  onClick={() => {
                    this.updateSoftStrePost();
                  }}
                >
                  Save
                </button>
              </Modal.Footer>
            </Modal>
            {/* END EDIT MODAL */}
            {/* SUCCESS MODAL */}
            <Modal
              id="mwidth"
              show={showSuccess}
              onHide={() => {
                this.handleModelSuccess();
              }}
            >
              <Modal.Header>
                <div className="d-flex justify-content-between w-100">
                  <h1 className="fs-20 semi-bold">EDIT</h1>
                  <BsXLg
                    onClick={() => this.handleModelSuccess()}
                    className="crossview cp"
                  ></BsXLg>
                </div>
              </Modal.Header>
              <Modal.Body>
                <div className="row">
                  <div className="col-12 text-center">
                    <img
                      src={successimg}
                      alt="success"
                      className="successimg-new"
                    ></img>
                    <p className="fs-20 semi-bold text-center">
                      Strength Successfully Added !
                    </p>
                    <div className="clear20"></div>
                  </div>
                  <div className="col-12 col-md-12 col-lg-12 ml-auto text-center">
                    <Link className="black">
                      <button
                        type="button"
                        class="donebtn"
                        onClick={() => {
                          this.handleModelSix();
                        }}
                      >
                        DONE
                      </button>
                    </Link>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <button
                  className="btn btn-cancel fs-16"
                  onClick={this.handleModelSuccess}
                >
                  Cancel
                </button>
                <button className="btn btn-save fs-16">Save</button>
              </Modal.Footer>
            </Modal>
            {/* END SUCCESS MODAL */}
          </div>
        ) : (
          <PageNotFoundPage />
        )}
      </>
    );
  }
}

export default WebsiteDetails;
